module.exports = __webpack_public_path__ + "07cdb8cf499a26ae4753fe0ef6aeb414.png";